import styled from "@emotion/styled";
import type { TooltipProps } from "@mui/material";
import { Tooltip } from "@mui/material";
import type { HTMLAttributes, ReactNode } from "react";

import type { IconName } from "../icons";
import { Icon } from "../icons";

const InfoTooltipContainer = styled.div<{ $variant: "info" | "warning" }>`
  display: inline-block;
  margin: 0 5px;
  color: ${({ theme, $variant }) => ($variant === "warning" ? theme.warning : theme.primaryStrong)};
  cursor: pointer;
  pointer-events: all;
`;
type Props = HTMLAttributes<HTMLDivElement> & {
  tooltip: ReactNode;
  text?: string;
  icon?: IconName;
  tooltipPlacement?: TooltipProps["placement"];
  arrow?: TooltipProps["arrow"];
  variant?: "info" | "warning";
};

export const InfoTooltip = ({
  tooltip,
  text,
  tooltipPlacement = "top",
  icon = "info-circle",
  arrow = true,
  variant = "info",
  ...domAttrs
}: Props) => {
  return (
    <Tooltip title={tooltip} placement={tooltipPlacement} arrow={arrow}>
      <InfoTooltipContainer $variant={variant} {...domAttrs}>
        <Icon icon={icon} size={14} />
        {text && <span>{text}</span>}
      </InfoTooltipContainer>
    </Tooltip>
  );
};
